<template>
  <v-container>
    <ErrorSnackbar ref="errorSnackbar" position="top" :msg="errorSnackbarMsg" />
    <SnackbarSuccess ref="successSnackbar" position="top" :msg="successSnackbarMsg" />

    <v-row class="paddingdouble">
      <v-col cols="9" class="nonothing">
        <p class="breadcrumbs">
          <a href="https://prosas.com.br/dashboards" tag="button">Vitrines</a> » Nova Vitrine
        </p>
      </v-col>

      <v-col cols="3" class="nonothing">
        <p class="breadcrumbs text-right">
          <a href="https://prosas.com.br/dashboards/polls" tag="button" rel="noopener"> « Voltar</a>
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-sheet v-model="poll"></v-sheet>
        <keep-alive>
          <v-card class="fixedcard">
            <v-container class="pa-4 d-flex flex-column" align="center" justify="center" id="ajuda_dicas">
              <SideHelper ref="sideHelper" v-if="pollIsDraft()" @saveAsDraft="onSaveDraft" />
              <p class="texto_paragrafo">
                <strong>Os campos marcados com <span>*</span> são de preenchimento obrigatório.</strong>
              </p>
            </v-container>
          </v-card>
        </keep-alive>
      </v-col>

      <v-col cols="9">
        <v-sheet v-model="poll"></v-sheet>
        <keep-alive>
          <v-card>
            <v-container>
              <form-wizard @on-complete="onSave"
                shape="tab"
                color="#20c09e"
                nextButtonText="Prosseguir »"
                backButtonText="« Voltar"
                :finishButtonText="(poll && poll.id) ? 'Atualizar' : 'Cadastrar'"
                stepSize="xs"
              >
                  <h2 slot="title" class="d-none">Preencha sua votação</h2>
                  <tab-content title="Dados">
                    <DataForm ref="childData" :poll="poll" @getParams="getParams"></DataForm>
                  </tab-content>

                  <tab-content title="Projetos">
                    <ProjectForm ref="childProject" :poll="poll"></ProjectForm>
                  </tab-content>

                  <tab-content title="Configurações">
                    <ConfigForm ref="childConfig" :poll="poll" pollOpportunityQuestions="pollOpportunityQuestions"></ConfigForm>
                  </tab-content>
            </form-wizard>
            </v-container>
          </v-card>
        </keep-alive>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import SideHelper from '@/components/form/poll/sideHelper/SideHelperPollCreateEdit';

import DataForm from '@/components/form/poll/FormPollData';
import ProjectForm from '@/components/form/poll/FormPollProject';
import ConfigForm from '@/components/form/poll/FormPollConfig';

import ErrorSnackbar from '@/components/utils/SnackbarError';
import SnackbarSuccess from '@/components/utils/SnackbarSuccess';

import { mapState, mapActions } from "vuex";

export default {
  name: 'PollCreateEdit',
  components: {
    FormWizard,
    TabContent,
    SideHelper,
    DataForm,
    ProjectForm,
    ConfigForm,
    ErrorSnackbar,
    SnackbarSuccess,
  },
  beforeCreate() {
    var pollId = this.$route.params.id
    this.$store.dispatch( 'getPollConfiguration', {pollId} )
  },
  updated() {
    if( !this.poll || !this.pollOpportunityQuestions || !this.pollOpportunityQuestions.length ) return this.$refs.childConfig.loadItemsProjectData()
    this.$refs.childConfig.setFormData()
  },
  mounted() {
    if( !this.poll ) return this.$refs.childConfig.loadItemsProjectData()
    this.$refs.childConfig.setFormData()
  },
  data: () => ({
    hasErros: false,
    errorSnackbarMsg: '',
    successSnackbarMsg: '',
    pageType: '',
  }),
  computed: {
    ...mapState(["poll","pollOpportunityQuestions"]),
  },
  methods: {
    ...mapActions(["getPollConfiguration", "savePoll"]),
    pollIsDraft() {
      return (this.poll && this.poll.isDraft !== false);
    },
    showErrorAlert: function( errorMessage ) {
      this.errorSnackbarMsg = errorMessage
      this.$refs.errorSnackbar.show()
    },
    showSuccessAlert( successMessage ) {
      this.successSnackbarMsg = successMessage;
      this.$refs.successSnackbar.show();
    },
    getParams( val ) {
      this.pageType = val
    },
    validateAllForms: function() {
      let hasErrors = false;
      if( !this.$refs.childData.isFormValid() ) {
        hasErrors = true
      }
      if( !this.$refs.childProject.isFormValid() ) {
        hasErrors = true
      }
      if( !this.$refs.childConfig.isFormValid() ) {
        hasErrors = true
      }

      this.hasErros = hasErrors;
    },
    disableSaveButtons: function() {},
    async savePoll() {
      try{
        await this.$store.dispatch( 'savePoll' )
      }catch( error ) {
        this.showErrorAlert( "Nao foi possível salvar sua votação. Erro:" )
        return
      }
    },
    async onSave() {
      this.disableSaveButtons()
      this.$refs.childConfig.setPollData()
      this.validateAllForms()
      // if( this.hasErros ) {
      //   this.showErrorAlert( 'Há campos obrigatórios a serem completados ou corrigidos. Por favor, retorne e altere os campos destacados em vermelho' )
      //   return
      // }
      this.$store.commit( 'setDraft', false )
      try{
        await this.$store.dispatch( 'savePoll' )
      }catch( error ) {
        error.graphQLErrors.forEach((error_message) => {
          this.showErrorAlert( error_message.message )
        })
        return
      }
      this.$router.push('/poll/' + this.poll.id );
      setTimeout( () => document.location.reload(true) );
      this.showSuccessAlert( 'Alteração salva com sucesso!' );
    },
    async onSaveDraft() {
      this.disableSaveButtons()
      this.$refs.childConfig.setPollData()
      if( this.poll.isDraft === false ) {
        this.showErrorAlert( 'Não é possivel salvar a votação como rascunho' ) // Poll has already been validated
        return // TODO: WEAK VALIDATION. Gotta validate on back-end
      }
      this.$store.commit( 'setDraft', true )
      try{
        await this.$store.dispatch( 'savePoll' )
      }catch( error ) {
        this.showErrorAlert( "Nao foi possível salvar sua votação" )
        return
      }
      this.showSuccessAlert( 'Rascunho salvo com sucesso!' );
      this.$router.replace('/poll/' + this.poll.id + '/edit' );
    },
  },
};
</script>

<style lang="scss" scoped>
  .nonothing {
    margin: 0 !important;
    padding: 0 !important;
  }

  .breadcrumbs {
    color: #3b474b;
    font-weight: 600;
    font-size: 13px;
    margin: 0 16px;

    button {
      color: #2c92b8;
      cursor: pointer;
    }
  }
  .texto_paragrafo{
    color: #575757;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
    margin: 0;

    span {
      font-size: 16px;
      line-height: 10px;
      color: #2e9fac !important;
    }
  }

  .paddingdouble {
    padding: 24px 8px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/poll/PollCreateEdit.vue